export default __webpack_public_path__ + "static/media/Bloodtainted Hoop.960578ce.jpg";